// extracted by mini-css-extract-plugin
module.exports = {"container":"goodNews_container__2q4kQ","green":"goodNews_green__1pUAb","white":"goodNews_white__18zDR","icon":"goodNews_icon__2Inmj","row":"goodNews_row__D6pP5"};